'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = CancelOfferPricingLevel;

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CancelOfferPricingLevel(p) {

    var stayWithUsText = _react2['default'].createElement(
        'p',
        null,
        'Stay with us and enjoy an exclusive annual discount:'
    );

    var previousPrice = _react2['default'].createElement(
        'div',
        { className: 'previous-price' },
        _react2['default'].createElement(
            'span',
            { className: 'dollar' },
            '$'
        ),
        _react2['default'].createElement(
            'span',
            { className: 'price' },
            p.offerPlanInfo.originalPrice
        )
    );

    var largePrice = _react2['default'].createElement(
        'div',
        { className: 'large-price' },
        _react2['default'].createElement(
            'span',
            { className: 'dollar' },
            '$'
        ),
        _react2['default'].createElement(
            'span',
            { className: 'price' },
            p.offerPlanInfo.discountedPrice
        )
    );

    var selectOfferButton = _react2['default'].createElement(_button2['default'], {
        buttonText: 'Select Offer',
        buttonColor: 'cerulean',
        buttonClass: 'select-offer-button',
        buttonLink: '/account/acceptCustomerCancelOffer'
    });

    var or = _react2['default'].createElement(
        'div',
        { className: 'round-or' },
        'OR'
    );

    var continueToCancelButton = _react2['default'].createElement(_button2['default'], {
        buttonText: 'No thank you, cancel my plan',
        buttonColor: 'plume',
        buttonBorderColor: 'cerulean',
        buttonTextColor: 'cerulean',
        buttonClass: 'continue-to-cancel-button',
        buttonLink: '/account/declineCustomerCancelOffer'
    });

    return _react2['default'].createElement(
        'div',
        { className: 'm-cancel-offer-pricing-level text-center' },
        _react2['default'].createElement(
            'div',
            { className: 'm-cancel-offer-pricing-level--offer' },
            stayWithUsText,
            previousPrice,
            largePrice,
            selectOfferButton,
            or,
            continueToCancelButton
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/customer-cancel-offer/cancel-offer-pricing-level.jsx
 ** module id = 1041
 ** module chunks = 0
 **/